var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('empty-header',{attrs:{"componentPath":_vm.component}}),_c('MultitransfersModal',{on:{"confirm":function($event){_vm.confirmData = $event}}}),_c('MultitransfersConfirmModal',{attrs:{"confirm-data":_vm.confirmData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }